import Authorities from '../Authority';
import { AuthorityAccessory } from '../Authority/Authority.Accessory';
import { AuthorityAccountPayable } from '../Authority/Authority.AccountPayable';
import { AuthorityAccountReceivable } from '../Authority/Authority.AccountReceivable';
import { AuthorityArea } from '../Authority/Authority.Area';
import { AuthorityBank } from '../Authority/Authority.Bank';
import { AuthorityBosch } from '../Authority/Authority.Bosch';
import { AuthorityCashMovement } from '../Authority/Authority.CashMovement';
import { AuthorityCompanyAvailabilities } from '../Authority/Authority.CompanyAvailabilities';
import { AuthorityCostCenter } from '../Authority/Authority.CostCenter';
import { AuthorityCustomer } from '../Authority/Authority.Customer';
import { AuthorityDocumentType } from '../Authority/Authority.DocumentType';
import { AuthorityEmployee } from '../Authority/Authority.Employee';
import { AuthorityGroup } from '../Authority/Authority.Group';
import { AuthorityInformative } from '../Authority/Authority.Informative';
import { AuthorityInsurer } from '../Authority/Authority.Insurer';
import { AuthorityInventary } from '../Authority/Authority.Inventary';
import { AuthorityManufacter } from '../Authority/Authority.Manufacter';
import { AuthorityMatrix } from '../Authority/Authority.Matrix';
import { AuthorityNCM } from '../Authority/Authority.NCM';
import { AuthorityPart } from '../Authority/Authority.Part';
import { AuthorityPayment } from '../Authority/Authority.Payment';
import { AuthorityPlanAccount } from '../Authority/Authority.PlanAccount';
import { AuthorityProfile } from '../Authority/Authority.Profile';
import { AuthorityPurchase } from '../Authority/Authority.Purchase';
import { AuthorityResourceLimitationPeriods } from '../Authority/Authority.ResourceLimitationPeriods';
import { AuthoritySPED } from '../Authority/Authority.SPED';
import { AuthorityStockCorrection } from '../Authority/Authority.StockCorrection';
import { AuthorityStockTransfer } from '../Authority/Authority.StockTransfer';
import { AuthoritySupplier } from '../Authority/Authority.Supplier';
import { AuthorityTask } from '../Authority/Authority.Task';
import { AuthorityTef } from '../Authority/Authority.Tef';
import { AuthorityUser } from '../Authority/Authority.User';

export const COMBO_ON = [
  ...Object.values(AuthorityBank),
  ...Object.values(AuthorityPlanAccount),
  ...Object.values(AuthorityDocumentType),
  ...Object.values(AuthorityArea),
  ...Object.values(AuthorityTask),
  ...Object.values(AuthorityNCM),
  ...Object.values(AuthorityInsurer),
  ...Object.values(AuthorityCostCenter),
  ...Object.values(AuthorityEmployee).filter(
    (role) =>
      role !== AuthorityEmployee.ENABLE_EMPLOYEE_ACCESS_IN_YARD_MANAGEMENT,
  ),
  ...Object.values(AuthorityAccessory),
  ...Object.values(AuthorityPayment),
  ...Object.values(AuthorityCustomer),
  ...Object.values(AuthoritySupplier),
  ...Object.values(AuthorityManufacter),
  ...Object.values(AuthorityGroup),
  ...Object.values(AuthorityPart),
  ...Object.values(AuthorityInventary),
  ...Object.values(AuthorityAccountPayable),
  ...Object.values(AuthorityAccountReceivable),
  ...Object.values(AuthorityCashMovement),
  ...Object.values(AuthorityMatrix),
  ...Object.values(AuthorityProfile),
  ...Object.values(AuthorityUser).filter(
    (role) => role !== AuthorityUser.CONFIGURATION_USER_ACCOUNT_AMAZON,
  ),
  ...Object.values(AuthorityStockCorrection),
  ...Object.values(AuthorityInformative),
  ...Object.values(AuthorityStockTransfer),
  ...Object.values(AuthorityTef),
  ...Object.values(AuthorityPurchase).filter(
    (role) => role !== AuthorityPurchase.MOVIMENTATION_PURCHASE_PARTSLINK24,
  ),
  ...Object.values(AuthorityCompanyAvailabilities),
  ...Object.values(AuthorityResourceLimitationPeriods),
  ...Object.values(AuthoritySPED),
  ...Object.values(AuthorityBosch),

  // DEFAULT
  Authorities.DEFAULT_VIEW_MATRIX,
  Authorities.DEFAULT_INFORMATIVE,

  // WORKORDER
  Authorities.MOVIMENTATION_WORKORDER_AUTHORIZED_EDIT_ITEM,
  Authorities.MOVIMENTATION_WORKORDER_OPENED_EDIT_ITEM,
  Authorities.MOVIMENTATION_WORKORDER_PRINT,
  Authorities.MOVIMENTATION_WORKORDER_EDIT,
  Authorities.MOVIMENTATION_WORKORDER_ADD,
  Authorities.MOVIMENTATION_WORKORDER_BUDGET,
  Authorities.MOVIMENTATION_WORKORDER_OPENED_ITEM_CHANGE_DISCOUNT,
  Authorities.MOVIMENTATION_WORKORDER_OPENED_ITEM_CHANGE_VALUE,
  Authorities.MOVIMENTATION_WORKORDER_OPENED_ITEM_CHANGE_QUANTITY,
  Authorities.MOVIMENTATION_WORKORDER_ITEM_CHANGE_QUANTITY,
  Authorities.MOVIMENTATION_WORKORDER_VIEW_PART_COST_PRICE,
  Authorities.MOVIMENTATION_WORKORDER_PRINT_REPORT_OF_COST,
  Authorities.MOVIMENTATION_WORKORDER_PRINT_QUOTATION_MAP,
  Authorities.MOVIMENTATION_WORKORDER_PRINT_REPORT_FOR_WORKSHOP,
  Authorities.MOVIMENTATION_WORKORDER_PRINT_ADMINISTRATIVE_REPORT,
  Authorities.MOVIMENTATION_WORKORDER_ITEM_EDIT_DISCOUNT_VALUE,
  Authorities.MOVIMENTATION_WORKORDER_PART_EDIT_SALE_VALUE,
  Authorities.MOVIMENTATION_WORKORDER_SERVICE_EDIT_SALE_VALUE,
  Authorities.MOVIMENTATION_WORKORDER_CLOSED_REOPEN,
  Authorities.MOVIMENTATION_WORKORDER_IMPORT,
  Authorities.MOVIMENTATION_WORKORDER_ALLOW_SELLING_BELOW_COST_VALUE,
  Authorities.MOVIMENTATION_WORKORDER_VIEW,
  Authorities.MOVIMENTATION_WORKORDER_CANCELLED_REOPEN,
  Authorities.MOVIMENTATION_WORKORDER_CANCEL,
  Authorities.MOVIMENTATION_WORKORDER_CLOSE,
  Authorities.MOVIMENTATION_WORKORDER_GENERATE_FINANCIAL,
  Authorities.MOVIMENTATION_WORKORDER_AUTHORIZE,
  Authorities.MOVIMENTATION_WORKORDER_MAKE_SALE_ABOVE_CREDIT_LIMIT,
  Authorities.MOVIMENTATION_WORKORDER_GIVE_DISCOUNT_OVER_LIMIT,
  Authorities.MOVIMENTATION_WORKORDER_RESTORE_ITEMS,
  Authorities.MOVIMENTATION_WORKORDER_DELETE_ITEM,
  Authorities.MOVIMENTATION_WORKORDER_EDIT_ITEM,
  Authorities.MOVIMENTATION_WORKORDER_ADD_ITEM,
  Authorities.MOVIMENTATION_WORKORDER_ADD_COMPLEMENT,
  Authorities.MOVIMENTATION_WORKORDER_OPENED_ITEM_CHANGE_COST_PRICE,
  Authorities.MOVIMENTATION_WORKORDER_EDIT_OF_OTHER_BUDGETIST,
  Authorities.MOVIMENTATION_WORKORDER_ITEM_ADD_SALE_VALUE_BELOW_MINIMUM_MARGIN,
  Authorities.MOVIMENTATION_WORKORDER_ITEM_EDIT_COST_PRICE,
  Authorities.MOVIMENTATION_WORKORDER_SELECT_ANOTHER_EMPLOYEE,
  Authorities.MOVIMENTATION_WORKORDER_CHANGE_TYPE,
  Authorities.MOVIMENTATION_WORKORDER_INCLUDE_SUPPLIED_PARTS,
  Authorities.MOVIMENTATION_WORKORDER_ITEM_VIEW_INFORMATION,
  Authorities.MOVIMENTATION_WORKORDER_ALLOW_EMPTY_ESTIMATED_LEAVE_DATE,
  Authorities.MOVIMENTATION_WORKORDER_CLOSED_BLOCK_EDIT_FRANCHISES,
  Authorities.MOVIMENTATION_WORKORDER_ITEM_SAVE_WITHOUT_INFORMING_COST,
  Authorities.MOVIMENTATION_WORKORDER_ITEM_SAVE_WITHOUT_INFORMING_SUPPLIER,
  Authorities.MOVIMENTATION_WORKORDER_ADD_DISCOUNT_PERCENTAGE_GREATER_THAN_DEFINED_BY_THE_COMPANY,
  Authorities.MOVIMENTATION_WORKORDER_GIVE_DISCOUNT_OUTSOURCED_SERVICES,
  Authorities.MOVIMENTATION_WORKORDER_AUTHORIZED_EDIT_CLOSING_DATE,
  Authorities.MOVIMENTATION_WORKORDER_VIEW_INDICATORS_PAGE,

  // PURCHASE
  Authorities.MOVIMENTATION_PURCHASE_VIEW_PURCHASE_GROUPS,
  Authorities.MOVIMENTATION_PURCHASE_SHOPPING_GROUPING,

  // REPORT
  Authorities.REPORT_VIEW_ACCOUNTS_RECEIVABLE_REPORTS,
  Authorities.REPORT_VIEW_ACCOUNTS_PAYABLE_REPORTS,
  Authorities.REPORT_VIEW_PURCHASE_REPORTS,
  Authorities.REPORT_VIEW_MOVIMENTATION_WORKORDER_REPORTS,
  Authorities.REPORT_REPORTS,
  Authorities.REPORT_PRODUCTIVE_VIEW,
  Authorities.REPORT_INVENTORY_VIEW,
  Authorities.REPORT_PRINT_WITH_VALUES,

  // COMPANY
  Authorities.REGISTER_COMPANY_EDIT,
  Authorities.REGISTER_COMPANY_VIEW,
  Authorities.REGISTER_COMPANY_REGISTRATION_COMPANY,
  Authorities.REGISTER_COMPANY_REGISTRATION,

  // STOCK CORRECTION
  Authorities.MOVIMENTATION_STOCKCORRECTION,

  // EMPLOYEE COMMISSION
  Authorities.VIEW_EMPLOYEE_COMMISSION,
];
